import React from 'react';
import { createPortal } from 'react-dom';
import { X, ShieldAlert, Lock, CheckCircle2, Ban } from 'lucide-react';

// 证券记录的图片查看器（后台记录页、后台图片管理、前台图片管理共用）：最终图 / 字段图 / 主图 / 客户对话图 / 客户资料图，有哪张显示哪张
export function ImageViewer({ rec, onClose }) {
  const items = [
    ['最终图', rec.images?.combined], ['字段图', rec.images?.fields], ['主图', rec.images?.main], ['客户对话图', rec.images?.chat], ['客户资料图', rec.images?.profile],
  ].filter(([, u]) => u);
  return createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 2147483000, background: 'rgba(0,0,0,0.92)', overflowY: 'auto', padding: 'calc(56px + env(safe-area-inset-top, 0px)) 12px calc(24px + env(safe-area-inset-bottom, 0px))' }}>
      <button onClick={onClose} style={{
        position: 'fixed', top: 'calc(14px + env(safe-area-inset-top, 0px))', right: 'calc(14px + env(safe-area-inset-right, 0px))', background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '50%', width: 36, height: 36, cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}><X size={18} color="white" /></button>
      {items.length === 0 && <p style={{ color: '#fff', textAlign: 'center' }}>没有可查看的图片{rec.files_cleaned ? '（已导出并清理）' : ''}</p>}
      {items.map(([label, url]) => (
        <div key={label} onClick={e => e.stopPropagation()} style={{ maxWidth: 520, margin: '0 auto 16px' }}>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginBottom: 6 }}>{label}</div>
          <img src={url} alt={label} style={{ width: '100%', borderRadius: 8, background: '#fff', display: 'block' }} />
        </div>
      ))}
    </div>,
    document.body
  );
}

// 记录状态角标：已计入 / 待核实 / 已作废 / 已锁定 / 草稿
export function StatusBadge({ status }) {
  const base = { display: 'inline-flex', alignItems: 'center', gap: 3 };
  if (status === 'confirmed') return <span className="badge badge-success" style={base}><CheckCircle2 size={11} /> 已计入</span>;
  if (status === 'pending') return <span className="badge badge-warning" style={base}><ShieldAlert size={11} /> 待核实</span>;
  if (status === 'rejected') return <span className="badge badge-danger" style={base}><Ban size={11} /> 已作废</span>;
  if (status === 'locked') return <span className="badge badge-danger" style={base}><Lock size={11} /> 已锁定</span>;
  return <span className="badge badge-info">草稿</span>;
}
